import { useWoody } from '../../woody/woody.js';
import { useQuery } from '@tanstack/react-query';
import { shareTokensQueryKeys } from './shareTokensQueryKeys.js';
import { isQueryEnabled } from '@fabric-app/queries/utilities';

const useQueryResourceShareTokens = (resourceId, options) => {
  const { client } = useWoody();
  return useQuery({
    queryKey: shareTokensQueryKeys.shareTokensPerResourceId(resourceId),
    queryFn: async () => {
      const res = await client.v2({
        endpoint: "/v2/resources/{resourceId}/share-token",
        params: {
          resourceId
        }
      });
      return res.data.shareTokens;
    },
    ...options,
    enabled: isQueryEnabled([
      !!resourceId,
      options?.enabled ?? true
    ])
  });
};

export { useQueryResourceShareTokens };
//# sourceMappingURL=useQueryResourceShareTokens.js.map
